<template>
  <PageHeaderLayout>
    <div class="main-page-content">
      <template v-if="viewMode === 'pending'">
        <div class="sub-page-header">
          <div>
            <el-button size="mini" icon="el-icon-arrow-left" @click="backToBillList">返回</el-button>
            <span class="sub-page-title">选择开票人</span>
          </div>
          <div class="sub-page-info">
            <span>{{ currentBill.company_name }}</span>
            <span>{{ currentBill.channel_name }}</span>
            <span>待开票金额：{{ pendingSummary.total_invoice_amount || currentBill.pending_invoice_amount || '0.00' }}</span>
          </div>
        </div>

        <ApeTable
          ref="pendingTable"
          :data="pendingList"
          :columns="pendingColumns"
          :loading="loadingStaus"
          :pagingData="pendingPagingData"
          highlight-current-row
          @selectList="handlePendingSelection"
          @switchPaging="switchPendingPaging"
        >
          <el-table-column slot="first-column" type="selection" width="55" align="center" />
        </ApeTable>

        <div class="footer-actions">
          <span>已选择 {{ selectedPendingRows.length }} 条，合计 {{ selectedPendingAmount }}</span>
          <el-button type="primary" :disabled="!selectedPendingRows.length" @click="openApplyConfirmPage">
            申请开票
          </el-button>
        </div>
      </template>

      <template v-if="viewMode === 'applyConfirm'">
        <div class="sub-page-header">
          <div>
            <el-button size="mini" icon="el-icon-arrow-left" @click="backToPendingRecords">返回</el-button>
            <span class="sub-page-title">确认开票记录</span>
          </div>
          <div class="sub-page-info">
            <span>{{ currentBill.company_name }}</span>
            <span>{{ currentBill.channel_name }}</span>
            <span>已选择 {{ selectedPendingRows.length }} 条</span>
            <span>合计：{{ selectedPendingAmount }}</span>
          </div>
        </div>

        <div class="apply-page-content">
          <el-alert
            title="请确认本次申请开票的记录，确认后进入开票信息填写页面。"
            type="warning"
            show-icon
            :closable="false"
          />
          <el-table :data="selectedPendingRows" class="confirm-table">
            <el-table-column prop="id" label="记录ID" />
            <el-table-column prop="bill_id" label="第三方账单ID" />
            <el-table-column prop="invoice_amount" label="开票金额" />
            <el-table-column prop="biz_servicer_id" label="开票服务商ID" />
            <el-table-column prop="status_desc" label="状态" />
          </el-table>
          <div class="footer-actions">
            <el-button @click="backToPendingRecords">返回上一步</el-button>
            <el-button type="primary" @click="openApplyPage">确认并填写开票信息</el-button>
          </div>
        </div>
      </template>

      <template v-if="viewMode === 'apply'">
        <div class="sub-page-header">
          <div>
            <el-button size="mini" icon="el-icon-arrow-left" @click="backToApplyConfirmPage">返回</el-button>
            <span class="sub-page-title">填写开票信息</span>
          </div>
          <div class="sub-page-info">
            <span>{{ currentBill.company_name }}</span>
            <span>{{ currentBill.channel_name }}</span>
            <span>已选择 {{ applyForm.selected_count || 0 }} 条</span>
            <span>合计：{{ applyForm.selected_amount || '0.00' }}</span>
          </div>
        </div>

        <div v-loading="applyLoading" class="apply-page-content">
          <el-form
            ref="applyForm"
            :model="applyForm"
            :rules="applyRules"
            label-position="top"
          >
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="开票单位">
                  <el-input v-model="applyForm.invoice_title" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纳税人识别号">
                  <el-input v-model="applyForm.org_code" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="税源地">
                  <el-input v-model="applyForm.channel_name" disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="选中金额">
                  <el-input v-model="applyForm.selected_amount" disabled />
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="发票类型" prop="invoice_type">
              <el-radio-group v-model="applyForm.invoice_type">
                <el-radio
                  v-for="item in invoiceTypeOptions"
                  :key="item.value"
                  :label="String(item.value)"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="开票内容" prop="invoice_content">
              <el-select
                v-model="applyForm.invoice_content"
                filterable
                clearable
                placeholder="请选择开票内容"
                style="width: 100%"
              >
                <el-option
                  v-for="item in contentOptions"
                  :key="getContentValue(item)"
                  :label="getContentLabel(item)"
                  :value="getContentValue(item)"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="是否纸质发票" prop="is_paper_invoice">
              <el-radio-group v-model="applyForm.is_paper_invoice">
                <el-radio label="y">是</el-radio>
                <el-radio label="n">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="收件人" prop="receiver">
                  <el-input v-model="applyForm.receiver" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收件人手机号" prop="receiver_phone">
                  <el-input v-model="applyForm.receiver_phone" />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="收件地址" prop="receiver_address">
                  <el-input v-model="applyForm.receiver_address" type="textarea" :rows="2" />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="收件邮箱" prop="receiver_email">
                  <el-input v-model="applyForm.receiver_email" />
                </el-form-item>
              </el-col>
            </el-row>

            <div class="selected-bills">
              <div class="selected-bills-title">已选择 {{ applyForm.selected_count || 0 }} 条待开票记录</div>
              <el-table :data="applyInitInfo.selected_bills || []" size="mini" max-height="260">
                <el-table-column prop="bill_id" label="第三方账单ID" min-width="140" />
                <el-table-column prop="invoice_amount" label="金额" min-width="120" />
                <el-table-column prop="status_desc" label="状态" min-width="100" />
              </el-table>
            </div>
          </el-form>

          <div class="footer-actions">
            <el-button @click="backToApplyConfirmPage">返回上一步</el-button>
            <el-button type="primary" :loading="applySubmitting" @click="submitApply">
              提交开票申请
            </el-button>
          </div>
        </div>
      </template>
    </div>
  </PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
  },
  data() {
    return {
      viewMode: 'pending',
      loadingStaus: false,
      applyLoading: false,
      applySubmitting: false,
      currentBill: {},
      pendingList: [],
      selectedPendingRows: [],
      pendingSummary: {},
      pendingPagingData: this.createPagingData(),
      pendingColumns: [
        { title: '记录ID', value: 'id', header_align: 'center', align: 'center' },
        { title: '第三方账单ID', value: 'bill_id', header_align: 'center', align: 'center' },
        { title: '开票金额', value: 'invoice_amount', header_align: 'center', align: 'center' },
        { title: '开票服务商ID', value: 'biz_servicer_id', header_align: 'center', align: 'center' },
        { title: '状态', value: 'status_desc', header_align: 'center', align: 'center' },
      ],
      applyForm: this.createApplyForm(),
      applyRules: {
        invoice_content: [{ required: true, message: '请选择开票内容', trigger: 'change' }],
        invoice_type: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        is_paper_invoice: [{ required: true, message: '请选择是否纸质发票', trigger: 'change' }],
        receiver: [{ validator: this.validatePaperInvoiceField, trigger: 'blur' }],
        receiver_phone: [{ validator: this.validatePaperInvoiceField, trigger: 'blur' }],
        receiver_address: [{ validator: this.validatePaperInvoiceField, trigger: 'blur' }],
      },
      applyInitInfo: {},
      contentOptions: [],
      invoiceTypeOptions: [
        { value: '1', label: '增值税专票' },
        { value: '2', label: '增值税普票' },
      ],
    }
  },
  computed: {
    selectedPendingAmount() {
      return this.formatMoney(this.sumAmount(this.selectedPendingRows, 'invoice_amount'))
    },
  },
  methods: {
    createPagingData() {
      return {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
      }
    },
    createApplyForm() {
      return {
        ids: [],
        invoice_title: '',
        org_code: '',
        selected_amount: '',
        selected_count: 0,
        invoice_content: '',
        invoice_type: '2',
        is_paper_invoice: 'n',
        receiver: '',
        receiver_phone: '',
        receiver_address: '',
        receiver_email: '',
      }
    },
    initCurrentBill() {
      const query = this.$route.query || {}
      this.currentBill = {
        company_id: query.company_id,
        channel_account: query.channel_account,
        company_account_id: query.company_account_id,
        company_name: query.company_name,
        channel_name: query.channel_name,
        pending_invoice_amount: query.pending_invoice_amount,
      }
    },
    validatePaperInvoiceField(rule, value, callback) {
      if (this.applyForm.is_paper_invoice !== 'y') {
        callback()
        return
      }
      if (rule.field === 'receiver' && !value) {
        callback(new Error('请输入收件人'))
        return
      }
      if (rule.field === 'receiver_phone' && !value) {
        callback(new Error('请输入收件人手机号'))
        return
      }
      if (rule.field === 'receiver_address' && !value) {
        callback(new Error('请输入收件地址'))
        return
      }
      callback()
    },
    buildCommonParams(row = {}) {
      const companyId = row.company_id || this.currentBill.company_id || this.mxCompanyId
      const channelAccount = row.channel_account || this.currentBill.channel_account || this.mxSettlementId
      const companyAccountId = row.company_account_id || this.currentBill.company_account_id
      const params = {}
      if (companyId) params.company_id = companyId
      if (channelAccount) params.channel_account = channelAccount
      if (companyAccountId) params.company_account_id = companyAccountId
      return params
    },
    getPagingInfo(refName, type) {
      const table = this.$refs[refName]
      if (table && table.getPagingInfo) {
        const pagingInfo = table.getPagingInfo(type)
        if (type === 'search') {
          pagingInfo.current_page = 1
        }
        return pagingInfo
      }
      return { current_page: 1, page_size: 10 }
    },
    normalizeListResp(result) {
      if (!result) {
        return { list: [], pages: { total: 0 } }
      }
      if (Array.isArray(result)) {
        return { list: result, pages: { total: result.length } }
      }
      return {
        list: result.data || result.list || [],
        pages: result.pages || { total: (result.data || result.list || []).length },
      }
    },
    async loadPendingRecords(type) {
      this.loadingStaus = true
      const params = {
        ...this.buildCommonParams(this.currentBill),
        ...this.getPagingInfo('pendingTable', type),
      }
      try {
        const result = await this.$api.getNewTaxInvoicePendingRecords(params)
        const { list, pages } = this.normalizeListResp(result)
        this.pendingSummary = {
          total_invoice_amount: result && result.total_invoice_amount,
        }
        this.pendingList = list.map((row) => ({
          ...row,
          status_desc: row.status_desc || row.status || '待开票',
        }))
        this.pendingPagingData.total = (pages && pages.total) || 0
        this.pendingPagingData.page_size = pages && pages.page_size
        this.pendingPagingData.offset = pages && pages.offset
      } finally {
        this.loadingStaus = false
      }
    },
    switchPendingPaging() {
      this.loadPendingRecords()
    },
    handlePendingSelection(list) {
      this.selectedPendingRows = list || []
    },
    openApplyConfirmPage() {
      if (!this.selectedPendingRows.length) {
        this.$message.warning('请至少选择一条待开票记录')
        return
      }
      this.viewMode = 'applyConfirm'
    },
    async openApplyPage() {
      this.viewMode = 'apply'
      this.applyLoading = true
      const ids = this.selectedPendingRows.map((row) => row.id)
      try {
        const result = await this.$api.getNewTaxInvoiceApplyInit({
          ...this.buildCommonParams(this.currentBill),
          ids,
        })
        this.applyInitInfo = result || {}
        this.contentOptions = this.extractInvoiceContents(result)
        this.invoiceTypeOptions = (result && result.invoice_type_options && result.invoice_type_options.length)
          ? result.invoice_type_options
          : this.invoiceTypeOptions
        const purchaserInfo = (result && result.purchaser_info) || {}
        this.applyForm = {
          ...this.createApplyForm(),
          ids: (result && result.selected_ids) || ids,
          invoice_title: purchaserInfo.invoice_title || '',
          org_code: purchaserInfo.org_code || '',
          channel_name: this.currentBill.channel_name,
          selected_amount: (result && result.selected_amount) || this.selectedPendingAmount,
          selected_count: (result && result.selected_count) || ids.length,
          invoice_type: String((this.invoiceTypeOptions[0] && this.invoiceTypeOptions[0].value) || '2'),
        }
        if (this.$refs.applyForm) {
          this.$refs.applyForm.clearValidate()
        }
      } finally {
        this.applyLoading = false
      }
    },
    extractInvoiceContents(result) {
      if (!result) return []
      if (Array.isArray(result.invoice_contents)) return result.invoice_contents
      if (result.invoice_content_result && result.invoice_content_result.data) {
        return result.invoice_content_result.data.invoice_contents || []
      }
      return []
    },
    getContentLabel(item) {
      if (typeof item === 'string') return item
      return item.label || item.name || item.invoice_content || item.content || item.value || ''
    },
    getContentValue(item) {
      if (typeof item === 'string') return item
      return item.value || item.invoice_content || item.content || item.name || item.label || ''
    },
    resetApplyPage() {
      this.applyLoading = false
      this.applySubmitting = false
      this.applyInitInfo = {}
      this.contentOptions = []
      this.applyForm = this.createApplyForm()
      if (this.$refs.applyForm) {
        this.$refs.applyForm.clearValidate()
      }
    },
    backToApplyConfirmPage() {
      this.viewMode = 'applyConfirm'
      this.resetApplyPage()
    },
    backToPendingRecords() {
      this.viewMode = 'pending'
      this.resetApplyPage()
    },
    backToBillList(refresh = false) {
      this.$router.push({
        path: '/new_tax_invoice',
        query: refresh ? { refresh: Date.now() } : {},
      })
    },
    submitApply() {
      this.$refs.applyForm.validate(async (valid) => {
        if (!valid) return
        this.applySubmitting = true
        try {
          const payload = {
            ...this.buildCommonParams(this.currentBill),
            ids: this.applyForm.ids,
            invoice_content: this.applyForm.invoice_content,
            invoice_type: this.applyForm.invoice_type,
            receiver: this.applyForm.receiver,
            receiver_phone: this.applyForm.receiver_phone,
            receiver_address: this.applyForm.receiver_address,
            receiver_email: this.applyForm.receiver_email,
            is_paper_invoice: this.applyForm.is_paper_invoice,
          }
          await this.$api.batchApplyNewTaxInvoice(payload)
          this.$message.success('开票申请已提交')
          this.backToBillList(true)
        } finally {
          this.applySubmitting = false
        }
      })
    },
    sumAmount(list, field) {
      return (list || []).reduce((total, item) => total + Number(item[field] || 0), 0)
    },
    formatMoney(value) {
      const numberValue = Number(value || 0)
      return numberValue.toFixed(2)
    },
  },
  mounted() {
    this.initCurrentBill()
    this.loadPendingRecords('search')
  },
}
</script>

<style lang="scss" scoped>
.sub-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.sub-page-title {
  margin-left: 12px;
  font-size: 16px;
  font-weight: 600;
}

.sub-page-info span {
  margin-left: 18px;
  color: #606266;
}

.apply-page-content {
  padding: 20px;
  background: #fff;
  border: 1px solid #ebeef5;
}

.confirm-table {
  margin-top: 16px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}

.selected-bills {
  margin-top: 12px;
}

.selected-bills-title {
  margin-bottom: 8px;
  font-weight: 600;
}
</style>
